import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="hero-content">
        <h1 className="hero-title">
          <span className="title-line">GOLD IS</span>
          <span className="title-line gold-text glow">EATING</span>
          <span className="title-line">EVERYTHING</span>
        </h1>

        <p className="hero-subtitle">
          While others chase narratives, <span className="gold-text">$GOLD</span> follows the only asset 
          that has preserved wealth for 5,000 years. Central banks are buying. Smart money is accumulating. 
          The golden bull run is just getting started.
        </p>

        <div className="hero-stats">
          <div className="hero-stat">
            <span className="stat-value gold-text">$4,983</span>
            <span className="stat-label">Gold ATH</span>
          </div>
          <div className="hero-stat">
            <span className="stat-value gold-text">+30%</span>
            <span className="stat-label">YTD Return</span>
          </div>
          <div className="hero-stat">
            <span className="stat-value gold-text">∞</span>
            <span className="stat-label">Upside</span>
          </div>
        </div>

        <div className="hero-buttons">
          <button className="btn-primary">
            <span>Buy $GOLD</span>
            
          </button>
          <a href="https://www.dextools.io" target="_blank" rel="noopener noreferrer" className="btn-secondary">
            <span>View Chart</span>
            <img src="https://cdn.worldvectorlogo.com/logos/dextools.svg" alt="DexTools" className="btn-icon-img" />
          </a>
        </div>

        <div className="hero-contract">
          <span className="contract-label">Contract Address:</span>
          <code className="contract-address" onClick={() => navigator.clipboard.writeText('0xd33794883aE317d753478478543adbeA5aCa5CBE')}>
            0xd337...5CBE <span className="copy-icon">📋</span>
          </code>
        </div>

        <div className="hero-scroll">
          <span>Scroll to explore</span>
          <div className="scroll-indicator">
            <div className="scroll-dot"></div>
          </div>
        </div>
      </div>

      <div className="hero-visual">
        <img 
          src="https://investingnews.com/media-library/gold-bars-with-stock-charts.jpg?id=31288047&width=1200&height=800&quality=70&coordinates=0%2C1%2C0%2C1" 
          alt="Gold Bars with Stock Charts" 
          className="hero-image"
        />
      </div>
    </section>
  );
};

export default Hero;
